import $ from 'jquery';
import LP from '../0-lp';

LP.dlgLanguages = {
    prepare: function (selector, params) {
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.Dialog.open($.extend({
                    name: 'languages',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    sizeable: true,
                    width: 600,
                    height: 600,
                    onLoad: LP.dlgLanguages.init
                }, params));
            }
            return false;
        });
    },

    init: function () {
        LP.dlgLanguages.initHandlers();
        LP.dlgLanguages.refreshList();
    },

    initHandlers: function () {
        $('.lp-langselect').off('change').on('change', LP.dlgLanguages.langSelected);
        $('[action="deleteLanguage"]').off('click').on('click', LP.dlgLanguages.deleteLang);
    },

    refreshList: function () {
        let $form = $('#lp-languages-dialog');
        let $tbody = $form.find('tbody');
        let $rows = $tbody.find('tr');

        // add empty field at the end if there isn't one yet
        if ($rows.last().find('.lp-langselect').val() != '') {
            $form.siblings('table').find('tr').clone().appendTo($tbody);
            LP.dlgLanguages.initHandlers();
        }

        // reindex fields
        let counter = 0;
        $rows.each(function (index, node) {
            // delete field if no language is selected and it's not the last field
            let $node = $(node);
            if ($node.find('.lp-langselect').val() == '' && index != $rows.length - 1) {
                $node.remove();
                return;
            }

            $node.find('[name="default"]').each(function (iindex, inode) {
                $(inode).val(counter);
            });

            counter++;
        });

    },

    langSelected: function () {
        var root = $(this).parent().parent();
        $('.codeCol', root).html(this.value);

        if (this.value == '') {
            $('.lp-langname', root).val('');
        } else {
            $('#lp-dlg-button-submit').attr('disabled', 'disabled');
            window.Browser.send('backend/getNativeLangName/', 'polllang=' + this.value, function (json) {
                $('.lp-langname', root).val(json.langname);
                $('#lp-dlg-button-submit').removeAttr('disabled');
            });
        }

        LP.dlgLanguages.refreshList();
    },

    deleteLang: function () {
        $(this).parents('tr').remove();
        LP.dlgLanguages.refreshList();
    }
};